import React, { Component } from 'react';

import {emojiUrlForRating} from '../../utils';

class AverageRatingBar extends Component {
  render(){
    const selected = Math.floor(this.props.rating + 0.5);

    return (
      <svg width='100%' height='65'>
        {/*BAR*/}
        <g>
          <rect x='0' y='35' width='20%' height='5' fill='#b50909'/>
          <rect x='20%' y='35' width='20%' height='5' fill='#ff5728'/>
          <rect x='40%' y='35' width='20%' height='5' fill='#fede27'/>
          <rect x='60%' y='35' width='20%' height='5' fill='#47b834'/>
          <rect x='80%' y='35' width='20%' height='5' fill='#138401'/>
        </g>
        {/*EMOJI*/}
        <g>
          <image
            x='10%'
            y={selected === 0 ? 0 : 5}
            height={selected === 0 ? 32 : 24}
            opacity={selected === 0 ? '1':'0.25'}
            xlinkHref={emojiUrlForRating(0)}
            transform={selected === 0 ? 'translate(-28)': 'translate(-12)'}
          />
          <image
            x='30%'
            y={selected === 1 ? 0 : 5}
            height={selected === 1 ? 32 : 24}
            opacity={selected === 1 ? '1':'0.25'}
            xlinkHref={emojiUrlForRating(1)}
            transform={selected === 1 ? 'translate(-28)': 'translate(-12)'}
          />
          <image
            x='50%'
            y={selected === 2 ? 0 : 5}
            height={selected === 2 ? 32 : 24}
            opacity={selected === 2 ? '1':'0.25'}
            xlinkHref={emojiUrlForRating(2)}
            transform={selected === 2 ? 'translate(-28)': 'translate(-12)'}
          />
          <image
            x='70%'
            y={selected === 3 ? 0 : 5}
            height={selected === 3 ? 32 : 24}
            opacity={selected === 3 ? '1':'0.25'}
            xlinkHref={emojiUrlForRating(3)}
            transform={selected === 3 ? 'translate(-28)': 'translate(-12)'}
          />
          <image
            x='90%'
            y={selected === 4 ? 0 : 5}
            height={selected === 4 ? 32 : 24}
            opacity={selected === 4 ? '1':'0.25'}
            xlinkHref={emojiUrlForRating(4)}
            transform={selected === 4 ? 'translate(-28)': 'translate(-12)'}
          />
        </g>
        {/*RATING NUMBER*/}
        <g>
          <text
            x={`${selected * 20 + 10}%`}
            y={24}
            fontSize='24'
            fontWeight='bold'
            transform='translate(6)'
          >
            {Number.parseFloat(this.props.rating + 1).toFixed(1)}
          </text>
        </g>
        <g>
          <text
            x={0}
            y={60}
            fontSize='18'
            fontWeight='bold'
          >
            1
          </text>
          <text
            x='50%'
            y={60}
            fontSize='1rem'
            textAnchor='middle'
          >
            {this.props.text}
          </text>
          <text
            x='100%'
            y={60}
            fontSize='18'
            fontWeight='bold'
            transform='translate(-12)'
          >
            5
          </text>
        </g>
      </svg>
    )
  }
}

export default AverageRatingBar;



// WEBPACK FOOTER //
// ./src/shared/components/AverageRatingBar/index.js